import type { FaireProductEntity } from "../../entity_types/product";

export const p_8a96kuxuje: FaireProductEntity = {
  token: "p_8a96kuxuje",
  type: "product",
  name: "AD3782 - Belted Sheer Lace Maxi Dress",
  brandToken: "b_9uxjeigntn",
  brandName: "Able",
  imageUrl:
    "https://cdn.faire.com/fastly/1d37b11d34bcc1fe50a5f52fe88c3a5016cbd5a291051bfd58173aa0485018e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71a469acc8b0ee8320b2e087c941a528f9d826fe58833d316ccf2cc50c9c093f.jpeg",
    "https://cdn.faire.com/fastly/f10f595867120190ac63a44008b7216e4de06aa3c4127bc2724cc66af43b4c7a.jpeg",
    "https://cdn.faire.com/fastly/bf8a5631c8d6823457e1fea262bfd9834365166f13b5ca774c9c6f4e358013b3.jpeg",
    "https://cdn.faire.com/fastly/579867f92c5d27cc339f016a221ae3dfe0b4d07018082d5061b55bd652ac376b.jpeg",
    "https://cdn.faire.com/fastly/8f1493207bae927cf9ca371cf4c94ba8a6e945732ddc1ed410a5ed71287567d3.jpeg",
    "https://cdn.faire.com/fastly/b3719ab29af109552725345b847da0078770bbfdc0522dea0efa05957c652c52.jpeg",
    "https://cdn.faire.com/fastly/8847905ec080a8b2c98d3361150393a9839775a52b47489f9d5c05241a7d95e2.png",
    "https://cdn.faire.com/fastly/00b5dadb2811c173c45d4b6157af843af34cbabdd0e6568f66ddc6c50aaaa2bf.png",
    "https://cdn.faire.com/fastly/9798afb3f16e29964dbf0e5634753eedea44c28b455d67c87e5fe3bf97c35a3c.png",
  ],
  priceDollars: 189,
  description:
    "- Elegant round scoop neckline with a classic fitted bodice.\n- Long sheer lace sleeves with a matching ankle-length maxi hemline.\n- Attached wide waist sash accented with a gold-tone organic hoop buckle.\n- Slim, figure-skimming fit that flows into a gentle A-line skirt.\n\nModel measurements: 5'8\" tall\nModel is wearing a US size Small\n\n92% NYLON 8% SPAN\nMade in China",
  tags: [],
  msrpDollars: 378,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:05.622Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
